import { useState } from 'react'
import { getExperimentList, setEx, showEx } from './core'

export function useExperiment(name) {
  const [exp, setExp] = useState(showEx(name))

  const setExperiment = (val) => {
    setEx(name, val)
    setExp(val)
  }

  return [exp, setExperiment]
}

export function useExperimentsList(list) {
  const [expList, setExpList] = useState(getExperimentList(list))

  const toggleExperiment = (name, newVal) => {
    setEx(name, newVal)
    setExpList((tempList) => {
      tempList[name] = newVal
      return { ...tempList }
    })
  }
  const sortedList = Object.keys(expList)
    .sort()
    .map((name) => ({ name, value: Boolean(expList[name]) }))

  return [sortedList, toggleExperiment]
}
